/* eslint-disable no-irregular-whitespace */
import styled, { css } from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';

interface IStyleValuationBodyContainerAndBodyForm {
  isResultAvailable?: boolean;
  isMobileView?: boolean;
}

const SLabelBody = styled.h5`
  position: relative;
  display: block;
  padding: 10px 20px;
  font-size: 14px;
  font-family: ProximaNovaRg;
  border-bottom: 1px solid ${color.gainsboro};
  background-color: ${color.light};
  border-radius: 3px;
`;

const SValuationBodyResult = styled.div`
  position: relative;
  display: block;
  border: 1px solid ${color.gainsboro};
  border-radius: 3px;

  h5 {
    border-radius: 3px 3px 0 0 !important;
  }
`;

// prettier-ignore
const SValuationBodyContainer = styled.div < IStyleValuationBodyContainerAndBodyForm >`
  position: relative;
  display: block;
  font-size: 14px;
  color: ${color.highempahis};

  ${({ isResultAvailable }) =>
    isResultAvailable &&
    css`
    display: grid;
    position: relative;
    grid-template-columns: 49% 48%;
    grid-column-gap: 30px;
    `}

  ${({ isResultAvailable, isMobileView }) =>
    isResultAvailable &&
    isMobileView &&
    css`
      display:block;
      grid-template-columns:unset;
      grid-gap:unset;

      ${SValuationBodyResult} {
        border:unset;
      }
    `}

  > * {
    font-size: 14px;
    font-family: ProximaNovaRg;
    background-color: ${color.light};
  }
`;

const SValuationFormWrapper = styled.div`
  position: relative;
  display: block;
  padding: 10px 20px 20px 20px;
`;

// prettier-ignore
const SValuationBodyForm = styled.div<IStyleValuationBodyContainerAndBodyForm>`
  position: relative;
  display: block;
  border-left: unset;
  border-right: unset;
  border-radius: 3px;

  h5 {
    border-radius: 3px 3px 0 0 !important;
  }

    ${({ isResultAvailable }) =>
      isResultAvailable &&
      css`
        height: fit-content;
      `}
    @media
    ${device.tablet} {
    border: 1px solid ${color.gainsboro};
  }
`;

const SValuationResultWrapper = styled.div`
  position: relative;
  display: block;
  padding: 10px 20px 20px 20px;
`;

const Label = styled(Text).attrs((props) => ({
  as: 'label',
}))`
  color: ${color.dimgray};
  display: block;
  font-size: 14px;
  font-family: var(--bold-font);
  font-weight: 700px;
  margin-bottom: ${
    // @ts-expect-error
    ({ mb }) => mb || '0px'
  };
`;

const StockValueContainer = styled.div`
  position: relative;
  display: block;
  margin-bottom: 30px;
`;

const ConsensusTargetContainer = styled.div`
  position: relative;
  display: block;
  margin-bottom: 30px;
`;

const NoteContainer = styled.div`
  position: relative;
  display: block;
  margin-bottom: 30px;
`;

export {
  SLabelBody,
  SValuationBodyContainer,
  SValuationBodyForm,
  SValuationBodyResult,
  SValuationFormWrapper,
  SValuationResultWrapper,
  Label,
  StockValueContainer,
  ConsensusTargetContainer,
  NoteContainer,
};
